
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P25-E1',
    audio: 'img/FriendsPlus/Page25/Audio/audio-e1-p25.mp3',
    video: '',
    component: D1,
    padding: 0,
    textAlign: 'center',
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page25/E1/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page25/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page25/Audio/tieude-e1-p25.mp3' },
        { url: 'img/FriendsPlus/Page25/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page25/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page25/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page25/E1/6.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page25/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page25/E1/8.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page25/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page25/E1/10.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page25/E1/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page25/E1/12.jpg' },
      ],

    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P25-E2',
    audio: '',
    video: '',
    component: UI,
    // exerciseKey: '',
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page25/E2/1.jpg' },
      ]
    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P25-E3',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    textAlign: 'center',
    maxLength: 1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page25/E3/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page25/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/3.jpg', input: true, answer: "?" },
        { url: 'img/FriendsPlus/Page25/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page25/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/6.jpg', input: true, answer: "," },
        { url: 'img/FriendsPlus/Page25/E3/7.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/8.jpg', input: true, answer: "," },
        { url: 'img/FriendsPlus/Page25/E3/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page25/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page25/E3/11.jpg', input: true, answer: "." },
        { url: 'img/FriendsPlus/Page25/E3/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page25/E3/13.jpg' },
      ],

    ]
  },
  4: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P25-E4',
    audio: '',
    video: '',
    component: D1,
    maxLength: 65,
    hideBtnFooter: true,
    isAllowSubmit: false,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page25/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page25/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page25/E4/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page25/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page25/E4/6.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E4/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page25/E4/8.jpg' },
        { url: 'img/FriendsPlus/Page25/E4/9.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E4/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page25/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page25/E4/12.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page25/E4/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page25/E4/14.jpg' },
      ],

    ]
  },
}

export default json;